exports.determineActiveLink = ({ item, location }) => {
    if (item.name === 'Home' && location.pathname !== '/') {
        return false;
    }
    return location.pathname.startsWith(item.path);
};



// WEBPACK FOOTER //
// ./src/helpers/sideBar.js